import { MsalProvider } from '@azure/msal-react';
import { Layout } from '@organisms/Layout';
import { initGA, logPageView, msalInstance, scrollTop } from '@utils';
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';
import {
  BeforeYouStart,
  Confirmation,
  EmailConfirmationReport,
  BikesLocation,
  YourDetails,
  TestLandingPage,
  UploadPhotoPage,
  SelectHireCompany,
  IssueDetails,
  TellUsMorePage,
} from './components/pages';
import { RoutesList, steps } from './routes/Routes';
import { basename } from './routes/basename';
import { InternalServerErrorTemplate, NotFoundErrorTemplate } from '@templates';

function App() {
  useEffect(() => {
    initGA();
    logPageView();

    // Log page views on route change
    const logPageViewOnRouteChange = () => logPageView();
    window.addEventListener('popstate', logPageViewOnRouteChange);

    return () =>
      window.removeEventListener('popstate', logPageViewOnRouteChange);
  }, []);
  // It's important that the Router component is above the pages component because you'll need to use the useHistory hook before rendering MsalProvider
  return (
    <Router basename={basename}>
      <RouteChangeTracker />
      <Pages />
    </Router>
  );
}


function Pages() {
  const location = useLocation();

  useEffect(() => {
    scrollTop();
  }, [location.pathname]);

  return (
    <MsalProvider instance={msalInstance}>
      <Layout steps={steps}>
        <Routes>
          <Route
            path={RoutesList.TEST_LANDING_PAGE}
            element={<TestLandingPage />}
          />
          <Route path={RoutesList.WHAT_IS_ISSUE} element={<IssueDetails />} />
          <Route
            path={RoutesList.WHAT_HIRE_COMPANY}
            element={<SelectHireCompany />}
          />
          <Route path={RoutesList.BIKES_HOME} element={<BeforeYouStart />} />
          <Route path={RoutesList.UPLOAD_PHOTO} element={<UploadPhotoPage />} />
          <Route path={RoutesList.BIKES_LOCATION} element={<BikesLocation />} />
          <Route path={RoutesList.YOUR_DETAILS} element={<YourDetails />} />
          <Route path={RoutesList.TELL_US_MORE} element={<TellUsMorePage />} />
          <Route
            path={RoutesList.EMAIL_CONFIRMATION_REPORT}
            element={<EmailConfirmationReport />}
          />
          <Route path={RoutesList.CONFIRMATION} element={<Confirmation />} />
          <Route
            path={RoutesList.INTERNAL_SERVER_ERROR}
            element={<InternalServerErrorTemplate />}
          />
          <Route
            path={RoutesList.NOT_FOUND}
            element={<NotFoundErrorTemplate />}
          />
        </Routes>
      </Layout>
    </MsalProvider>
  );
}

export const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    logPageView();
  }, [location]);

  return null;
};

export default App;
